module.exports = __webpack_public_path__ + "mastodon-not-found-afb3fe71154b0c7518f25c70897c03d2.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mastodon-not-found.png
// module id = 194
// module chunks = 65